import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Phone, Users, ArrowRight, Shield } from "lucide-react";

const products = [
  {
    icon: Phone,
    key: "communications",
    color: "text-textBlue",
    bgColor: "bg-blueLight",
  },
  {
    icon: Shield,
    key: "security",
    color: "text-red-600",
    bgColor: "bg-red-50",
  },
  {
    icon: Users,
    key: "aiPeopleCounting",
    color: "text-purple-600",
    bgColor: "bg-purple-50",
  },
];

const ProductsSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 px-6 md:px-16 sm:px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-textBlue text-white text-md px-6 py-2 rounded-full mb-4">
            {t("products.label")}
          </span>
          <h2 className="text-4xl md:text-3xl sm:text-2xl font-bold text-gray-800">
            {t("products.title")}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-1 gap-8">
          {products.map((product, index) => {
            const Icon = product.icon;

            return (
              <div
                key={index}
                className="bg-gray-50 p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className={`${product.bgColor} w-16 h-16 rounded-full flex items-center justify-center mb-4`}>
                  <Icon className={`w-8 h-8 ${product.color}`} />
                </div>
                <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                  {t(`products.${product.key}.title`)}
                </h3>
                <p className="text-gray-600 mb-4">
                  {t(`products.${product.key}.description`)}
                </p>
                <Link
                  to={`/products/${product.key}`}
                  className="inline-flex items-center gap-2 text-textBlue hover:text-textBlueDark font-semibold transition-colors"
                >
                  {t("products.viewMore")}
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
